import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M12-.001c-6.629 0-12.002 5.373-12.002 12 0 5.99 4.389 10.955 10.126 11.856v-8.386H7.077v-3.47h3.047V9.357c0-3.008 1.792-4.67 4.533-4.67 1.313 0 2.686.235 2.686.235v2.953H15.83c-1.49 0-1.956.926-1.956 1.875v2.25h3.329l-.532 3.47h-2.797v8.386C19.611 22.955 24 17.99 24 12 24 5.372 18.627-.001 12-.001z",
    fill: "#1877F2"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "m16.67 15.469.533-3.47h-3.329V9.75c0-.95.465-1.874 1.956-1.874h1.513V4.92s-1.373-.234-2.686-.234c-2.741 0-4.533 1.661-4.533 4.669V12H7.077v3.469h3.047v8.386a12.099 12.099 0 0 0 3.75 0v-8.386h2.797z",
    fill: "#fff"
  })
], -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}
export default render